/**
 * Country / province code helpers shared by the quote pages.
 * quotes.js expects these globals — templates load this file before it.
 * The guard makes a double include harmless.
 */
if (typeof window.getProvinceCode !== 'function') {

const PROVINCE_CODES = {
    "Alabama": "AL",
    "Alaska": "AK",
    "American Samoa": "AS",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "Armed Forces Americas": "AA",
    "Armed Forces Europe": "AE",
    "Armed Forces Pacific": "AP",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "District of Columbia": "DC",
    "Federated States of Micronesia": "FM",
    "Florida": "FL",
    "Georgia": "GA",
    "Guam": "GU",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Marshall Islands": "MH",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Northern Mariana Islands": "MP",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Palau": "PW",
    "Pennsylvania": "PA",
    "Puerto Rico": "PR",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virgin Islands": "VI",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY"
};

const getProvinceCode = (state_name) => PROVINCE_CODES[state_name];

const COUNTRIES_FETCH_TRIES = 3;

const setCountryCodes = async (reload = false) => {
  const localCountries = localStorage.getItem('_arbor_local_countries');
  if (localCountries) {
    return JSON.parse(localCountries);
  }

  let lastError;
  for (let attempt = 1; attempt <= COUNTRIES_FETCH_TRIES; attempt++) {
    try {
      const response = await fetch('/services/countries.json', {
        method: "GET",
        headers: {"Content-Type": "application/json"}
      });
      if (!response.ok) {
        throw new Error('countries.json failed: ' + response.status);
      }

      const data = await response.json();
      localStorage.setItem('_arbor_local_countries', JSON.stringify(data));

      return data;
    } catch (error) {
      lastError = error;
      if (attempt < COUNTRIES_FETCH_TRIES) {
        await new Promise(resolve => setTimeout(resolve, 500 * attempt));
      }
    }
  }

  throw lastError;
}

const getCountryCodeByName = async (countryName) => {
  if (Array.isArray(countryName) && countryName.length === 1) {
    countryName = countryName[0];
  }

  let localCountries = localStorage.getItem('_arbor_local_countries');

  if (!localCountries) {
    localCountries = await setCountryCodes(false);
  } else {
    localCountries = JSON.parse(localCountries);
  }

  const country = localCountries.find(c => c.name.toLowerCase() === countryName.toLowerCase());

  if (country) {
    return country.code;
  } else {
    return 'Country Not Found';
  }
}

window.setCountryCodes = setCountryCodes;
window.getCountryCodeByName = getCountryCodeByName;
window.getProvinceCode = getProvinceCode;
}
